import React, { useEffect, useState } from 'react';
import ApiClient from '../../utils/ApiClient';

// Three ways to start a V2 plan: a purchase order, a product + units, or (deep link only) a region refill.
export default function SourcePicker({ source, onPick }) {
  const [pos, setPos] = useState([]);
  const [asin, setAsin] = useState(source?.type === 'asin' ? source.value : '');
  const [units, setUnits] = useState(source?.units ? String(source.units) : '');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (source?.type === 'asin') {
      setAsin(source.value || '');
      setUnits(source.units ? String(source.units) : '');
    }
  }, [source]);

  useEffect(() => {
    let live = true;
    ApiClient.get('/api/shipment-planner/supplier-pos')
      .then((res) => { if (live) setPos(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (live) setError('Could not load purchase orders'); });
    return () => { live = false; };
  }, []);

  const input = 'rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-2 py-1 text-sm';
  return (
    <div className="flex flex-wrap items-end gap-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3">
      <label className="text-sm text-gray-700 dark:text-gray-300">
        <span className="block text-xs mb-1">Purchase order</span>
        <select aria-label="Purchase order" className={input}
          value={source?.type === 'po' ? source.value : ''}
          onChange={(e) => e.target.value && onPick({ type: 'po', value: e.target.value })}>
          <option value="">Select a PO…</option>
          {pos.map((p) => (
            <option key={p.poNumber} value={p.poNumber}>
              {`PO ${p.poNumber} · ${p.poDate || 'no date'} · ${p.unshippedUnits ?? p.totalOpenUnits ?? 0} open`}
            </option>
          ))}
        </select>
      </label>
      <form className="flex items-end gap-2" onSubmit={(e) => {
        e.preventDefault();
        const a = asin.trim().toUpperCase();
        const n = parseInt(units, 10);
        if (a && n > 0) onPick({ type: 'asin', value: a, units: n });
      }}>
        <label className="text-sm text-gray-700 dark:text-gray-300">
          <span className="block text-xs mb-1">Product</span>
          <input aria-label="ASIN" className={`${input} w-32`} value={asin} onChange={(e) => setAsin(e.target.value)} placeholder="ASIN" />
        </label>
        <input aria-label="Units" type="number" min="1" className={`${input} w-24`} value={units}
          onChange={(e) => setUnits(e.target.value)} placeholder="Units" />
        <button type="submit" className="rounded bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 text-sm">Load</button>
      </form>
      {source?.type === 'refill' && (
        <span className="text-sm text-gray-700 dark:text-gray-300">Refill regions for {source.value}</span>
      )}
      {error && <span className="text-sm text-red-600 dark:text-red-400">{error}</span>}
    </div>
  );
}
